export const validateGroupName = (name: string) => {
  switch (name) {
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'
    case 'categoriasIds':
      return 'categoriaCompacta'
    case 'categoriasSelectIds':
      return 'categoriaCompacta'
    case 'anosIds':
      return 'ano'
    case 'anosSelectIds':
      return 'ano'
    case 'mesesIds':
      return 'mes'
    case 'mesesSelectIds':
      return 'mes'
    case 'historicoIds':
      return 'historico'
    case 'historicoSelectIds':
      return 'historico'
    case 'operacaoIds':
      return 'gerenteOperacoes'
    case 'operacaoSelectIds':
      return 'gerenteOperacoes'
    case 'visualizationIds':
      return 'visualizacao'
    case 'dimensaoIds':
      return 'dimensao'
    default:
      return null
  }
}
